import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FormPanel, FormRichEditor, FormTextField } from '@eas/common-web';

export function Fields() {
  return (
    <FormPanel
      label={
        <FormattedMessage
          id="TAPIS__PARAGRAPH__DETAIL__PANEL_TITLE"
          defaultMessage="Základní informace"
        />
      }
    >
      <FormTextField
        name="location"
        label={
          <FormattedMessage
            id="TAPIS__PARAGRAPH__DETAIL__FIELD_LABEL__LOCATION"
            defaultMessage="Kód umístění"
          />
        }
        required={true}
        disabled={true}
      />
      <FormTextField
        name="label"
        label={
          <FormattedMessage
            id="TAPIS__PARAGRAPH__DETAIL__FIELD_LABEL__LOCATION"
            defaultMessage="Umístění"
          />
        }
        required={true}
        disabled={true}
      />

      <FormRichEditor
        name="text"
        label={
          <FormattedMessage
            id="TAPIS__PARAGRAPH__DETAIL__FIELD_LABEL__TEXT"
            defaultMessage="Text"
          />
        }
      />
    </FormPanel>
  );
}
